// src/pages/about/OurHomes.js
import React from "react";
import { Helmet } from "react-helmet";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Card from "../../components/Card";
import CardSection from "../../components/CardSection";
import currentProjects from "../../assets/images/who-we-are/current-projects.webp";
import completedProjects from "../../assets/images/who-we-are/completed-projects.webp";
import specialProjects from "../../assets/images/who-we-are/special-projects.webp";

const OurHomes = () => {
  const cards = [
    {
      title: "Current Projects",
      description:
        "Habitat Buffalo is actively constructing new homes across the Western New York area to provide affordable housing and strengthen community development. Additionally, they help families in need achieve homeownership, fostering stability and growth within the community.",
      link: "/projects/current",
      image: currentProjects,
    },
    {
      title: "Completed Projects",
      description:
        "Since 1985, we have built, rehabilitated, and repaired nearly 400 homes in neighborhoods throughout the greater Buffalo area. These efforts have significantly contributed to the availability of affordable housing and the revitalization of our communities.",
      link: "/projects/completed",
      image: completedProjects,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Our Homes - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Discover the homes built, rehabilitated, and repaired by Habitat for Humanity Buffalo. Learn about our current, completed, and special projects."
        />
      </Helmet>
      <Container className="container">
        <h1>Our Homes</h1>
        <h2 className="section-header primary">
          We've Been Building Affordable Housing Since 1985
        </h2>
        <div className="section">
          <p className="text-center">
            Habitat for Humanity Buffalo builds, rehabilitates, and repairs
            affordable and sustainable homes in partnership with hardworking,
            low-income families, individuals, and communities. Together with
            volunteers and future homeowners, Habitat Buffalo has improved the
            housing stock throughout our service area. Currently, Habitat
            Buffalo has invested significant resources in helping families,
            revitalizing neighborhoods, and creating more access to affordable
            housing. We invite you to join us in Building a Better Buffalo!
          </p>
        </div>
        <CardSection>
          {cards.map((card, index) => (
            <LazyLoad key={index} height={200} offset={100}>
              <Link
                to={card.link}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {" "}
                {/* Wrap Card with Link */}
                <Card
                  title={card.title}
                  description={card.description}
                  link={card.link}
                  image={card.image}
                />
              </Link>
            </LazyLoad>
          ))}
        </CardSection>
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
`;

export default OurHomes;
